import { User } from "../model/schemas/replit";

import { AuthUser1MutationBody, AuthUserDTORole, useAuthUser1 } from "@/common/api";
import { useAuthStore } from "@/common/lib";

export const useAuth = () => {
  // FIXME: имя метода на беке
  const query = useAuthUser1();
  const { isAuthenticated, id, role, saveAuth, clearAuth } = useAuthStore();

  const login = async (credentials: AuthUser1MutationBody) => {
    return query.mutateAsync(
      { data: credentials },
      {
        onSuccess: (response) => {
          if (response.data.payload) {
            saveAuth({ ...response.data.payload });
          }
        },
        onError: console.error,
      },
    );
  };

  // FIXME: заменить на useUser
  return {
    state: {
      user: null as unknown as User,
    },
    login,
    logout: clearAuth,
    query,
    auth: {
      id,
      role,
      isAuthenticated,
      isAdmin: role === AuthUserDTORole.ADMIN,
      isCargoOwner: role === AuthUserDTORole.CARGO_OWNER,
      isWagonOwner: role === AuthUserDTORole.WAGON_OWNER,
    },
  };
};
